import React from "react";
import {Button, Container, Form} from "react-bootstrap";
import {withTranslation} from "react-i18next";
import $ from 'jquery';
import {NavLink} from "react-router-dom";
import select2 from 'select2';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowLeft,
    faCheckSquare,
    faSquare,
    faFolderOpen,
    faFile,
    faChevronRight,
    faMinusSquare,
    faFolder,
    faChevronDown,
    faBars,
    faTable,
    faChevronUp,
    faCog,
} from "@fortawesome/free-solid-svg-icons";
import Navi from "../blocks/Navi";
import {contains} from "../../helpers/functions";
import Content from "../blocks/Content";
import IntervalForm from "../blocks/IntervalForm";

class LampSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: this.props.lamp.view_settings.structures,
            expanded: [],
            isValidate: false,
            intervals: this.props.lamp.view_settings.intervals,
            my_intervals: this.props.lamp.view_settings.my_intervals,
            interval: {
                name: '',
                start: '',
                end: '',
                is_edit: true,
            },
        };

        $(() => {
            let s = $('#select_show_in_card').select2();
            let s2 = $('#select_display_in_control').select2();
            let s3 = $('#select_display_in_block').select2();
            let s4 = $('#select_show_intervals').select2();
            let s5 = $('#select_terminal_id').select2();
            $('.select2-search').remove();

            s.on("change", this.props.onSetShowInCard);
            s2.on("change", this.props.onSetDisplayInControl);
            s3.on("change", this.props.onSetDisplayInBlock);
            s4.on("change", this.props.onSetShowIntervals);
            s5.on("change", this.props.onSetTerminalId);
        });
    }

    handleAddInterval = (event) => {
        event.preventDefault();
        this.setState({
            isValidate: false,
            my_intervals: [...this.state.my_intervals, this.state.interval],
        }, () => this.props.setMyIntervals(this.state.my_intervals));
    };

    handleDeleteInterval = (event) => {
        event.preventDefault();
        let interval_name = event.target.name.value;
        let my_intervals = this.state.my_intervals;
        let show_intervals = this.props.lamp.view_settings.show_intervals;
        let new_intervals = [];
        my_intervals.forEach(el => (el.name !== interval_name) && new_intervals.push(el));
        this.props.setMyIntervals(new_intervals);
        this.setState({isValidate: false, my_intervals: new_intervals});
        if (show_intervals.includes(interval_name)) {
            let new_show_intervals = [];
            show_intervals.forEach(el => (el !== interval_name) && new_show_intervals.push(el));
            this.props.onSetShowIntervals(event, new_show_intervals);
        }
    }

    handleOnChange = (event) => this.setState({interval: {...this.state.interval, [event.target.name]: event.target.value}});

    handleShowIntervalForm = () => this.setState({isValidate: !this.state.isValidate});

    getAllValues = (array) => {
        const allValues = [];
        const getValue = (arr) => arr.forEach(el => {
            if (el.children) {
                allValues.push(el.value);
                getValue(el.children);
            } else {
                allValues.push(el.value);
            };
        });
        getValue(array);
        return allValues;
    };

    handleCheckAll = () => {
        const checked = this.state.checked.length > 0 ? [] : this.getAllValues(this.props.lamp.structures);
        this.setState({checked}, () => this.props.onSetStructure(this.state.checked));
    };

    render() {
        let show_in_card = this.props.lamp.view_settings.show_in_card;
        let display_in_control = this.props.lamp.view_settings.display_in_control;
        let display_in_block = this.props.lamp.view_settings.display_in_block;
        let terminal_id = this.props.lamp.view_settings.terminal_id;
        let show_intervals_list = this.props.lamp.view_settings.show_intervals;
        let intervals = this.state.intervals;
        let my_intervals = this.state.my_intervals;
        let intervals_to_select = intervals.concat(my_intervals);
        let devices = this.props.lamp.devices;
        let devices_values = []
        for (let key in devices) {
            devices_values.push({ id: key, name: devices[key] })
        }

        return <>
                <div className={"Screen Startup"}>
                    <Content className="container">
                        <Form.Group className="d-flex align-items-center mb-4">
                            <Form.Label className="Label mb-0 mr-3" htmlFor="custom-switch">
                                {this.props.t('Auto update')}
                            </Form.Label>
                            <Form.Switch
                                onChange={this.props.onChange}
                                id="auto_update"
                                name="auto_update"
                                className="Control"
                                defaultChecked={this.props.lamp.view_settings.auto_update} />
                        </Form.Group>
                        <Form.Group className="d-flex align-items-center mb-4">
                            <Form.Label className="Label mb-0 mr-3" htmlFor="custom-switch">
                                {this.props.t('Quick switching')}
                            </Form.Label>
                            <Form.Switch
                                onChange={this.props.onChange}
                                id="quick_switching"
                                name="quick_switching"
                                className="Control"
                                defaultChecked={this.props.lamp.view_settings.quick_switching} />
                        </Form.Group>
                        <Form.Group className="mb-5">
                            <div className="Control">
                                <div className={`d-flex justify-content-between align-items-center mb-4`}>
                                    <Form.Label className="Label d-block" htmlFor="structures">
                                        {this.props.t('Businesses displayed in the pre-shift window control')}
                                    </Form.Label>
                                    <Button onClick={this.handleCheckAll} className={`Btn Btn_success display-6 text-nowrap`} style={{height: 'fit-content'}}>
                                        {this.props.t('All')}
                                        <FontAwesomeIcon className="rct-icon rct-icon-check ml-3" icon={this.state.checked.length > 0 ? faSquare : faCheckSquare}/>
                                    </Button>
                                </div>
                                <Form.Control type="hidden" onInput={this.props.onChange} name="structures"
                                    id="structures" value={JSON.stringify(this.props.lamp.view_settings.structures)}/>
                                <CheckboxTree
                                    nodes={this.props.lamp.structures}
                                    checked={this.state.checked}
                                    expanded={this.state.expanded}
                                    checkModel='all'
                                    showExpandAll
                                    expandOnClick
                                    onClick={()=>{}}
                                    iconsClass="fa5"
                                    icons={{
                                        check: <FontAwesomeIcon className="rct-icon rct-icon-check" icon={faCheckSquare}/>,
                                        uncheck: <FontAwesomeIcon className="rct-icon rct-icon-uncheck" icon={faSquare}/>,
                                        halfCheck: <FontAwesomeIcon className="rct-icon rct-icon-half-check" icon={faMinusSquare}/>,
                                        expandClose: <FontAwesomeIcon className="rct-icon rct-icon-expand-close" icon={faChevronRight}/>,
                                        expandOpen: <FontAwesomeIcon className="rct-icon rct-icon-expand-open" icon={faChevronDown}/>,
                                        expandAll: <FontAwesomeIcon className="rct-icon rct-icon-expand-all" icon={faChevronDown}/>,
                                        collapseAll: <FontAwesomeIcon className="rct-icon rct-icon-collapse-all" icon={faChevronUp}/>,
                                        parentClose: <FontAwesomeIcon className="rct-icon rct-icon-parent-close" icon={faFolder}/>,
                                        parentOpen: <FontAwesomeIcon className="rct-icon rct-icon-parent-open" icon={faFolderOpen}/>,
                                        leaf: <FontAwesomeIcon className="rct-icon rct-icon-leaf-close" icon={faFile}/>
                                    }}
                                    onCheck={checked => this.setState({checked}, () => this.props.onSetStructure(this.state.checked))}
                                    onExpand={expanded => this.setState({expanded})} />
                            </div>
                        </Form.Group>
                        <Form.Group className="d-flex align-items-center mb-4">
                            <Form.Label className="Label mr-3 mb-0">
                                {this.props.t('View')}
                            </Form.Label>
                            <Form.Control type="hidden" name="template" id="template" onInput={this.props.onChange} defaultValue={this.props.lamp.view_settings.template}/>
                            <Button className={`Btn js-view-radio ${this.props.lamp.view_settings.template === 'list' ? 'Btn_success' : 'Btn_secondary'} h-100 display-6 mr-2 px-3`} onClick={(e) => {
                                    this.props.viewToggleClass(e);
                                    this.props.onSetTemplateLamp('list');
                                }}>
                                <FontAwesomeIcon icon={faBars}/>
                            </Button>
                            <Button className={`Btn js-view-radio ${this.props.lamp.view_settings.template === 'grid' ? 'Btn_success' : 'Btn_secondary'} h-100 display-6 px-3 mr-2`} onClick={(e) => {
                                    this.props.viewToggleClass(e);
                                    this.props.onSetTemplateLamp('grid');
                                }}>
                                <FontAwesomeIcon icon={faTable}/>
                            </Button>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label className="Label d-block" htmlFor="show_last_hours">
                                {this.props.t('Show results for the last N hours')}
                            </Form.Label>
                            <Form.Control
                                type="number"
                                min="0"
                                max="99"
                                className="Field mw-100"
                                id="show_last_hours"
                                name="show_last_hours"
                                aria-describedby="passwordHelpBlock"
                                onChange={this.props.onChange}
                                defaultValue={this.props.lamp.view_settings.show_last_hours} />
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label className="Label d-block" htmlFor="terminal_id">
                                {this.props.t('Select the delivery terminal')}
                            </Form.Label>
                            <Form.Control type="hidden" onInput={this.props.onChange} id="terminal_id"
                                        name="terminal_id" value={JSON.stringify(this.props.lamp.view_settings.terminal_id)}/>
                            <Form.Control as="select" id="select_terminal_id" name="select_terminal_id"
                                        className="Field select2 select2-no-search mw-100 w-100" multiple>
                                {devices_values.map(el =>
                                    <option value={el.id} selected={contains(terminal_id, el.id)} key={el.id}>
                                        {el.name}
                                    </option>)}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label className="Label d-block d-flex justify-content-between align-items-center" htmlFor="show_intervals" >
                                {this.props.t('Display employees only at selected time intervals')}
                                <FontAwesomeIcon onClick={this.handleShowIntervalForm} className="ml-4 cursor-pointer" icon={faCog} />
                            </Form.Label>
                            <Form.Control type="hidden" onInput={this.props.onChange} id="show_intervals"
                                        name="show_intervals" value={JSON.stringify(this.props.lamp.view_settings.show_intervals)}/>
                            <Form.Control as="select" id="select_show_intervals" name="select_show_intervals"
                                        className="Field select2 select2-no-search mw-100 w-100" multiple >
                                {intervals_to_select && intervals_to_select.map((interval, i) =>
                                    <option value={interval.name} selected={contains(show_intervals_list, interval.name)} key={i}>
                                        {interval.name}
                                    </option>)}
                            </Form.Control>
                            {this.state.isValidate &&
                                <IntervalForm handleAddInterval={this.handleAddInterval}
                                            handleOnChange={this.handleOnChange}
                                            handleDeleteInterval={this.handleDeleteInterval}
                                            theme={this.props.theme}
                                            lamp={this.props.lamp}
                                            intervals={this.state.intervals}
                                            my_intervals={this.state.my_intervals} />}
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label className="Label d-block" htmlFor="sort_by">
                                {this.props.t('Sort by')}
                            </Form.Label>
                            <Form.Control as="select" id="sort_by" name="sort_by" className="Field mw-100" onChange={this.props.onChange}
                                        defaultValue={this.props.lamp.view_settings.sort_by}>
                                <option value="passage_dt" defaultChecked={this.props.lamp.view_settings.sort_by === 'passage_dt'}>
                                    {this.props.t('Passage date')}
                                </option>
                                <option value="title" defaultChecked={this.props.lamp.view_settings.sort_by === 'title'}>
                                    {this.props.t('Full name')}
                                </option>
                                <option value="number" defaultChecked={this.props.lamp.view_settings.sort_by === 'number'}>
                                    {this.props.t('Personal number')}
                                </option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label className="Label d-block" htmlFor="sort_type">
                                {this.props.t('Sort type')}
                            </Form.Label>
                            <Form.Control as="select" id="sort_type" name="sort_type" className="Field mw-100" onChange={this.props.onChange} defaultValue={this.props.lamp.view_settings.sort_type}>
                                <option value="descending" defaultChecked={this.props.lamp.view_settings.sort_type === 'descending'}>
                                    {this.props.t('Descending')}
                                </option>
                                <option value="ascending" defaultChecked={this.props.lamp.view_settings.sort_type === 'ascending'}>
                                    {this.props.t('Ascending')}
                                </option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label className="Label d-block" htmlFor="display_in_control">
                                {this.props.t('Display in pre-shift control')}
                            </Form.Label>
                            <Form.Control type="hidden" onInput={this.props.onChange} id="display_in_control"
                                        name="display_in_control" value={JSON.stringify(this.props.lamp.view_settings.display_in_control)}/>
                            <Form.Control as="select" id="select_display_in_control" name="select_display_in_control"
                                        className="Field select2 select2-no-search mw-100 w-100" multiple>
                                <option value="title" selected={contains(display_in_control, 'title')}>
                                    {this.props.t('Full name')}
                                </option>
                                <option value="number" selected={contains(display_in_control, 'number')}>
                                    {this.props.t('Personal number')}
                                </option>
                                <option value="structure" selected={contains(display_in_control, 'structure')}>
                                    {this.props.t('Structure')}
                                </option>
                                <option value="position" selected={contains(display_in_control, 'position')}>
                                    {this.props.t('Position')}
                                    </option>
                                <option value="passage_dt" selected={contains(display_in_control, 'passage_dt')}>
                                    {this.props.t('Passage date')}
                                    </option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label className="Label d-block" htmlFor="display_in_block">
                                {this.props.t('Display in pre-shift block')}
                            </Form.Label>
                            <Form.Control type="hidden" onInput={this.props.onChange} id="display_in_block"
                                        name="display_in_block" value={JSON.stringify(this.props.lamp.view_settings.display_in_block)}/>
                            <Form.Control as="select" id="select_display_in_block" name="select_display_in_block"
                                        className="Field select2 select2-no-search mw-100 w-100" multiple>
                                <option value="title" selected={contains(display_in_block, 'title')}>
                                    {this.props.t('Full name')}
                                </option>
                                <option value="number" selected={contains(display_in_block, 'number')}>
                                    {this.props.t('Personal number')}
                                </option>
                                <option value="structure" selected={contains(display_in_block, 'structure')}>
                                    {this.props.t('Structure')}
                                </option>
                                <option value="position" selected={contains(display_in_block, 'position')}>
                                    {this.props.t('Position')}
                                </option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label className="Label d-block" htmlFor="show_in_card">
                                {this.props.t('Show in card')}
                            </Form.Label>
                            <Form.Control type="hidden" onInput={this.props.onChange} id="show_in_card"
                                        name="show_in_card" value={JSON.stringify(this.props.lamp.view_settings.show_in_card)}/>
                            <Form.Control as="select" id="select_show_in_card" className="Field select2 select2-no-search mw-100 w-100" multiple>
                                {this.props.lamp.employee_properties.map((prop, key) => {
                                    if (prop.name !== "title" &&
                                        prop.name !== "number" &&
                                        prop.name !== "position" &&
                                        prop.name !== "structure")
                                    return <option key={key} selected={contains(show_in_card, prop.name)} value={prop.name}>{prop.name === "title" ? this.props.t('Full name') : prop.title}</option>
                                })}
                            </Form.Control>
                        </Form.Group>
                    </Content>
                </div>
                <Navi>
                    <Container className={`d-flex justify-content-between`}>
                        <NavLink to={"/"} className={`Btn Btn_success MuiButton`}>
                            <FontAwesomeIcon className="mr-4" icon={faArrowLeft}/>
                            <span>{this.props.t('Back')}</span>
                        </NavLink>
                        <Button type="submit" onClick={this.props.onSubmit} className="Btn SubmitBtn Btn_success">
                            {this.props.t('Save')}
                        </Button>
                    </Container>
                </Navi>
            </>
    }
}

export default withTranslation()(LampSettings);